"use client";

import React, { useEffect, useRef } from "react";
import useLocalStorage from "use-local-storage";

import { useParams } from "@/hooks/useParams";

//

export interface SavePromocodeProps {}

//

export const SavePromocode: React.FC<SavePromocodeProps> = ({}) => {
  const isSet = useRef(false);
  const [storagedPromocode, setStoragedPromocode] = useLocalStorage<string | null>(
    "promocode",
    "TRIAL",
  );

  const params = useParams();
  const promocodeParam = params.get("promocode");

  useEffect(() => {
    if (isSet.current) return;
    if (!storagedPromocode && promocodeParam) {
      params.set("promocode", null);
      params.replace();
      isSet.current = true;
      setStoragedPromocode(promocodeParam);
    }
  }, [params, promocodeParam, setStoragedPromocode, storagedPromocode]);

  return null;
};
